import { Editor  } from 'tinymce'

const  boxAlignments = ['center', 'right'] as const;
const classPrefix = 'mds-align-';

export const registerBoxAlignment = (editor: Editor) => {

	editor.ui.registry.addMenuButton('box-alignment', {
        icon: 'objects-align-left',
        tooltip: 'Alignment',
        fetch: (cb) => {
			const bottomNode = editor.selection.getNode();
			const node = bottomNode.closest('.mds-box-format');
			if (!node) return;
	
			const setTypeClass = (align?: typeof boxAlignments[number]) => {
				const addClass = align ? !node.classList.contains(classPrefix + align) : false;
				node.classList.remove(...boxAlignments.map(a => classPrefix + a));
				if (addClass) node.classList.add(classPrefix + align);
				editor.dispatch('Change')
			};
	
			cb([
				{
					type: 'togglemenuitem',
					value: 'auto',
					text: 'auto',
					onAction: () => setTypeClass(),
					active: !node.className.includes(classPrefix)
				},
				...boxAlignments.map(align => ({
					type: 'togglemenuitem' as const,
					value: classPrefix + align,
					text: align,
					icon: 'objects-align-' + align,
					onAction: () => setTypeClass(align),
					active: node.classList.contains(classPrefix + align)
				}))
			]);
		}
    })
}